import { connect } from 'react-redux';
import SiteAbortApprovalsList from './siteAbortApprovalsList';
import { bindActionCreators } from 'redux';
import {
  getSiteAbortApproval,
  acceptSiteStatusApproval,
  rejectAbortApproval,
} from 'services/redux/approvals/mrfApprovals/action';

const mapStateToProps = (state) => ({
  approvalList: state.mrfApprovalReducer.siteAbortApproval,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteAbortApproval,
      acceptSiteStatusApproval,
      rejectAbortApproval,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteAbortApprovalsList);
